import { Injectable } from '@angular/core';
import { GetClientsCommand, IGetClientsCommandParameters } from './command/getClients.command';
import { GetCountClientCommand, IGetCountClientCommandParameters } from './command/getCountClients.command';
import { AddClientCommand, IAddClientParameters } from './command/addClient.command';
import { IdentityService } from '../authentication/identity.service';
import { GetClientsUsersCommand, IGetClientsUsersCommandParameters, IGetClientsUsersResponse } from './command/getClientsUsersCommand.command';
import { GetCurrentAccountsCommand, IGetCurrentAccountsCommandParameters } from './command/getCurrentAccounts.command';
import { IUpdateCurrentAccountByClientByCarrierCommandParameters, UpdateCurrentAccountByClientByCarrierCommand } from './command/updateCurrentAccountByClientByCarrier.command';
import { AddCurrentAccountCommand, IAddCurrentAccountCommandParameters } from './command/addCurrentAccount.command';
import { FindByContainClientsWithoutCurrentAccount, IFindByContainClientsWithoutCurrentAccountParameters } from './command/findByContainClientsWithoutCurrentAccount.command';
import { GetPaymentsByCurrentAccountsCommand, IGetPaymentsByCurrentAccountsCommandParameters, IGetPaymentsByCurrentAccountsResponse } from './command/getPaymentsByCurrentAccounts.command';
import { AddPaymentCcCommand, IAddPaymentCcCommandParameters } from './command/addPaymentCc.command';
import { GetPaymentVoucherCommand, IGetPaymentVoucherCommandParameters, IGetPaymentVoucherResponse } from './command/getPaymentVoucher.command';
import { GetPaymentMethodsByUserCommand, IGetPaymentMethodsByUserCommandParameters } from './command/getPaymentMethodsByUser.command';
import { GetPassengersNoClientsByLastNameCommand, IGetPassengersNoClientsByLastNameParameters, IGetPassengersNoClientsByLastNameResponse } from './command/getPassengersNoClientsByLastName.command';
import { SortEnum } from '../enum/sortEnum.enum';
import { MultiRegionService } from '../multiregion/multiregion.service';
import { GetPassengersCommand, IGetPassengersCommandParameters } from './command/getPassengers.command';
import { GetClientCommand, IGetClientCommandParameters } from './command/getClient.command';
import { EditClientCommand, IEditClientParameters } from './command/editClient.command';
import { DeleteClientCommand, IDeleteClientParameters } from './command/deleteClient.command';
import { GetCurrentAccountClientCommand, IGetCurrentAccountClientCommandParameters } from './command/getCurrentAccountClient.command';
import { AddPassengerUserCommand, IAddPassengerUserParameters } from './command/addPassagerUser.command';
import { UpdatePassengerUserCommand, IUpdatePassengerUserParameters } from './command/updatePassengerUser.command';
import { ImportPassengerUsersCommand, IImportPassengerUsersResponse } from './command/importPassengerUsers.command';
import { IUpdateClientIsActiveCommand, IUpdateClientIsActiveCommandParameters, UpdateClientIsActiveCommand } from './command/updateClientIsActive.command';
import { ErrorsEnum } from '../enum/errors.enum';
import { GetFequentDestinationCommand, IGetFequentDestinationCommandParameters, IGetFequentDestinationResponse } from './command/getFrequentDestination.command';
import { PaginationResult } from '../models/custom-objects/pagination-result';
import { TravelsCheckingAccountResponse } from '../models/responses/travels-checking-account.response';
import { GetClientTravelsCheckingAccountCommand } from './command/get-client-travels-checking-account.command';
import { GetPassengersAddressesCommand, IGetPassengerAddressCommandParameters } from './command/getPassengersAddresses.command';
import { GetClientsUsersByContractorCommand, IGetClientsUsersByContractorCommandParameters, IGetClientsUsersByContractorResponse } from './command/getClientsUsersByContractorCommand.command';
import { PassengerResendSolicitudeCommand, IPassengerResendSolicitudeParameters } from './command/passengerResendSolicitude.command';
import { TranslateService } from '@ngx-translate/core';
import { GetClientByUserIdCommand } from './command/getClientByUserId.command';
import { GetPaymentMethodsByPaxCommand, IGetPaymentMethodsByPaxCommandCommandParameters } from './command/getPaymentMethodsPAX.command';
import { ConnectionServices } from '../authentication/connection/connection.service';
import { catchError, map, Observable, throwError } from 'rxjs';
import { IPassengerAddressDto, PaymentResponseDTO, SortGrid } from '../authentication/connection/interfaces/apiInterfaces';
import { CheckingAccountResponseDto, CurrentAccountGrid, GetPaymentRequestDTO, GridRequestDto, IAddPassengerUserRequestDto, PassengerResponseDTO } from '../interfaces/apiInterfaces';
import { AlertService } from '../components/alerts/alert.service';

@Injectable()
export class ClientsService {
  constructor(
    private _connectionService: ConnectionServices,
    private _alertService: AlertService,
    private _identityService: IdentityService,
    private _multiregionService: MultiRegionService,
    private _translateService: TranslateService
  ) { }

  public getPassengersNoClientsByLastName(
    clientLastName: string
  ): Observable<IGetPassengersNoClientsByLastNameResponse> {
    let getPassengersNoClientsByLastNameCommand = new GetPassengersNoClientsByLastNameCommand();
    getPassengersNoClientsByLastNameCommand.setParameters(<IGetPassengersNoClientsByLastNameParameters>{
      lastName: clientLastName,
      carrierUserId: this._identityService.userId
    });
    return this._connectionService
      .Request(getPassengersNoClientsByLastNameCommand)
      .pipe(
        map(data => {
          return data;
        }),
        catchError(error => {
          this._alertService.alertWarning('toast.clients.passenger', error);
          return throwError(() => false);
        })
      );
  }

  public getClientsUsersByFilter(
    filters: IGetClientsUsersCommandParameters
  ): Observable<Array<IGetClientsUsersResponse>> {
    const clientCommand = new GetClientsUsersCommand();
    clientCommand.setParameters(filters);
    return this._connectionService.Request(clientCommand).pipe(
      map(response => {
        // aquí puedes transformar el response si hace falta,
        // o simplemente devolverlo:
        return response;
      }),
      catchError(error => {
        // this._notificationsService.showHttpErrorMessage('toast.users.title', error);
        // throwError crea un Observable que emite error
        return throwError(() => false);
      })
    );
  }

  public getClientsUsers(
    terms: string
  ): Observable<Array<IGetClientsUsersResponse>> {
    const clientCommand = new GetClientsUsersCommand();
    clientCommand.setParameters(<IGetClientsUsersCommandParameters>{
      terms: terms,
      carrierId: this._identityService.userId
    });
    return this._connectionService.Request(clientCommand).pipe(
      map(response => {
        // aquí puedes transformar el response si hace falta,
        // o simplemente devolverlo:
        return response;
      }),
      catchError(error => {
        // this._notificationsService.showHttpErrorMessage('toast.users.title', error);
        // throwError crea un Observable que emite error
        return throwError(() => false);
      })
    );
  }

  // public getClientsUsersByContractor(
  //   terms: string
  // ): Observable<Array<IGetClientsUsersByContractorResponse>> {
  //   const clientCommand = new GetClientsUsersByContractorCommand();
  //   clientCommand.setParameters(<IGetClientsUsersByContractorCommandParameters>{
  //     terms: terms
  //   });
  //   return this._connectionService
  //     .Request(clientCommand)
  //     .pipe(
  //       map(response => {
  //         return response;
  //       }),
  //       catchError(error => {
  // }

  // public getClients(
  //   page: number,
  //   size: number,
  //   column: string,
  //   sort: SortEnum,
  //   find?: string,
  //   isPaxVip?: boolean
  // ): Observable<ClientGrid> {
  //   let command = new GetClientsCommand();
  //   command.setParameters(<IGetClientsCommandParameters>{
  //     carrierUserId: this._identityService.userId,
  //     column: column,
  //     page: page,
  //     size: size,
  //     sort: sort,
  //     find: find,
  //     isPaxVip
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .map(data => {
  //       const response = data as ClientGrid;
  //       return response;
  //     })
  //     .catch(error => {
  //       this._notificationsService.showHttpErrorMessage('toast.clients.title', error);
  //       return Observable.throw(false);
  //     });
  // }

  // public getTotalClients(): Observable<CountClientsDTO> {
  //   let command = new GetCountClientCommand();
  //   command.setParameters(<IGetCountClientCommandParameters>{
  //     carrierUserId: this._identityService.userId
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .map(data => {
  //       const response = data as CountClientsDTO;
  //       return response;
  //     })
  //     .catch(error => {
  //       return Observable.throw(false);
  //     });
  // }

  public getClient(id: number): Observable<PassengerResponseDTO> {
    let command = new GetClientCommand();
    command.setParameters(<IGetClientCommandParameters>{
      carrierUserId: this._identityService.userId,
      clientId: id.toString()
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map(data => {
          return data as PassengerResponseDTO;
        }),
        catchError(error => {
          this._alertService.alertWarning('toast.clients.title', error);
          return throwError(() => false);
        })
      );
  }

  // public getClientByUserID(id): Observable<PassengerResponseDTO> {
  //   let command = new GetClientByUserIdCommand();
  //   command.setParameters(<IGetClientCommandParameters>{
  //     clientId: id
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .map(data => {
  //       return data;
  //     })
  //     .catch(error => {
  //       this._notificationsService.showHttpErrorMessage('toast.clients.title', error);
  //       return Observable.throw(false);
  //     });
  // }

  public addClient(
    passengerUserId: number,
    fareId: number
  ): Observable<boolean> {
    let addClientCommand = new AddClientCommand(this._identityService.userId);
    addClientCommand.setParameters(<IAddClientParameters>{
      passengerUserId: passengerUserId,
      fareId: fareId
    });
    return this._connectionService
      .Request(addClientCommand)
      .pipe(
        map(data => {
          if (data !== null) {
            // this._alertService.alertSuccess(
            //   'toast.clients.title',
            //   'toast.shared.message.successful_message_add'
            // );
          }
          return true;
        }),
        catchError(error => {
          // this._alertService.alertWarning('toast.clients.title', error);
          console.log(error);
          return throwError(() => false);
        })
      );
  }

  public editClient(
    passengerAccount: number,
    fareId: number
  ): Observable<boolean> {
    let editClientCommand = new EditClientCommand(
      this._identityService.userId,
      passengerAccount.toString()
    );
    editClientCommand.setParameters(<IEditClientParameters>{
      passengerAccountId: passengerAccount,
      fareId: fareId
    });
    return this._connectionService
      .Request(editClientCommand)
      .pipe(
        map(data => {
          return true;
        }),
        catchError(error => {
          console.log(error);
          // this._notificationsService.('toast.clients.title', error);
          return throwError(() => false);
        })
      );
  }

  public getCurrentAccounts(
    currentAccount: GridRequestDto
  ): Observable<CurrentAccountGrid> {
    const getCurrentAccountsCommand = new GetCurrentAccountsCommand();
    getCurrentAccountsCommand.setParameters(<
      IGetCurrentAccountsCommandParameters
      >{
        carrierUserId: currentAccount.carrierUserId,
        column: currentAccount.column,
        page: currentAccount.page,
        size: currentAccount.size,
        sort: currentAccount.sort
      });

    return this._connectionService
      .Request(getCurrentAccountsCommand)
      .pipe(
        map(response => {
          return response as CurrentAccountGrid;
        }),
        catchError(error => {
          return throwError(() => false);
        })
      );
  }

  public getCurrentAccountClient(
    carrierUserId: string,
    passengerUserId: string
  ): Observable<CheckingAccountResponseDto> {
    const getCurrentClientAccountsCommand = new GetCurrentAccountClientCommand();
    getCurrentClientAccountsCommand.setParameters(<
      IGetCurrentAccountClientCommandParameters
      >{
        passengerUserId: passengerUserId,
        carrierUserId: carrierUserId
      });
    return this._connectionService
      .Request(getCurrentClientAccountsCommand)
      .pipe(
        map(data => {
          const response = data as CheckingAccountResponseDto;
          return response;
        }),
        catchError(error => {
          return throwError(() => false);
        })
      )
  }

  public updateCurrentAccount(
    carrierUserId: string,
    isActive: boolean,
    checkexceedingLimit: boolean,
    limit: number,
    passengerUserId: number
  ): Observable<any> {
    const command = new UpdateCurrentAccountByClientByCarrierCommand();
    command.setParameters(<
      IUpdateCurrentAccountByClientByCarrierCommandParameters
      >{
        isActive: isActive,
        exceedingLimit: checkexceedingLimit,
        limit: limit,
        carrierUserId: carrierUserId,
        passengerUserId: passengerUserId
      });
    return this._connectionService
      .Request(command)
      .pipe(
        map(response => {
          this._alertService.alertSuccess(
            'toast.checking_accounts.title',
            'toast.shared.message.successful_message_modify'
          );
          return response;
        }),
        catchError(error => {
          return throwError(() => false);
        })
      )
  }

  // public findByContainsWithoutCurrentAccount(
  //   lastName: string,
  //   carrierUserId: string
  // ): Observable<ClientsResponseDto[]> {
  //   const clientCommand = new FindByContainClientsWithoutCurrentAccount();
  //   clientCommand.setParameters(<
  //     IFindByContainClientsWithoutCurrentAccountParameters
  //   >{
  //     lastName: lastName,
  //     carrierUserId: carrierUserId
  //   });
  //   return this._connectionService
  //     .Request(clientCommand)
  //     .map(data => {
  //       const response = data as ClientsResponseDto[];
  //       return response;
  //     })
  //     .catch(error => {
  //       this._notificationsService.showHttpErrorMessage('toast.clients.title', error);
  //       return Observable.throw(false);
  //     });
  // }

  public addCurrentAccount(
    idClient: number,
    carrierUserId: string
  ): Observable<boolean> {
    let command = new AddCurrentAccountCommand();
    command.setParameters(<IAddCurrentAccountCommandParameters>{
      carrierUserId: carrierUserId,
      passengerUserId: idClient
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map(data => {
          this._alertService.alertSuccess(
            'toast.checking_accounts.title',
            'toast.shared.message.successful_message_add'
          );
          return true;
        }),
        catchError(error => {
          return throwError(() => false);
        })
      );
  }

  public getPaymentsByCurrentAccounts(
    paymentDto: GetPaymentRequestDTO
  ): Observable<IGetPaymentsByCurrentAccountsResponse> {
    const driverCommand = new GetPaymentsByCurrentAccountsCommand();
    driverCommand.setParameters(<
      IGetPaymentsByCurrentAccountsCommandParameters
      >{
        passengerUserId: paymentDto.passengerUserId,
        carrierUserId: paymentDto.carrierUserId,
        column: paymentDto.column,
        page: paymentDto.page,
        size: paymentDto.size,
        sort: paymentDto.sort
      });
    return this._connectionService
      .Request(driverCommand)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(error => {
          return throwError(() => false);
        })
      )
  }
  // public addPaymentCc(paymentDto: AddPaymentCcDTO): Observable<boolean> {
  //   let command = new AddPaymentCcCommand();
  //   command.setParameters(<IAddPaymentCcCommandParameters>{
  //     carrierUserId: paymentDto.carrierUserId,
  //     passengerUserId: paymentDto.passengerUserId,
  //     amount: paymentDto.amount,
  //     paymentMethod: paymentDto.paymentMethod,
  //     voucherName: paymentDto.voucherName,
  //     voucherFile: paymentDto.voucherFile,
  //     movementDate: paymentDto.movementDate
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .map(data => {
  //       this._notificationsService.showSuccessMessage(
  //         'toast.checking_accounts.payments',
  //         'toast.shared.message.successful_message_add'
  //       );
  //       return true;
  //     })
  //     .catch(error => {
  //       this._notificationsService.showHttpErrorMessage('toast.checking_accounts.payments', error);
  //       return Observable.throw(false);
  //     });
  // }

  public getPaymentVoucher(
    paymentId: string
  ): Observable<IGetPaymentVoucherResponse> {
    const getPaymentVoucherCommand = new GetPaymentVoucherCommand();
    getPaymentVoucherCommand.setParameters(<
      IGetPaymentVoucherCommandParameters
      >{
        paymentId: paymentId
      });
    return this._connectionService
      .Request(getPaymentVoucherCommand)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(error => {
          this._alertService.alertWarning(
            'toast.checking_account.receipt',
            error
          );
          return throwError(() => false);
        })
      )
  }

  // public getPaymentMethodsByUser(
  //   passengerUserId: string,
  //   carrierUserId: string
  // ): Observable<Array<PaymentMethodEnum>> {
  //   const getPaymentMethodsByUserCommand = new GetPaymentMethodsByUserCommand();
  //   getPaymentMethodsByUserCommand.setParameters(<
  //     IGetPaymentMethodsByUserCommandParameters
  //   >{
  //     passengerUserId: passengerUserId,
  //     carrierUserId: carrierUserId
  //   });
  //   return this._connectionService
  //     .Request(getPaymentMethodsByUserCommand)
  //     .map(response => {
  //       return response;
  //     })
  //     .catch(error => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.checking_accounts.payment_methods',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // public getPassengers(
  //   page: number,
  //   size: number,
  //   column: string,
  //   sort: SortEnum,
  //   search: string
  // ): Observable<any> {
  //   let command = new GetPassengersCommand();
  //   command.setParameters(<IGetPassengersCommandParameters>{
  //     sort: sort,
  //     size: size,
  //     page: page,
  //     column: column,
  //     carrierUserId: this._identityService.userId,
  //     search: search
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .map(response => {
  //       return response;
  //     })
  //     .catch(error => {
  //       this._notificationsService.showHttpErrorMessage('toast.clients.passenger', error);
  //       return Observable.throw(false);
  //     });
  // }
  public addPassagerUser(
    passengerUserRequestDto: IAddPassengerUserRequestDto,
    travelFareId?: number
  ): Observable<PassengerResponseDTO> {
    let addPassengerCommand = new AddPassengerUserCommand();
    addPassengerCommand.setParameters(<IAddPassengerUserParameters>{
      country: passengerUserRequestDto.country,
      firstName: passengerUserRequestDto.firstName,
      lastName: passengerUserRequestDto.lastName,
      email: passengerUserRequestDto.email,
      phone: passengerUserRequestDto.phone,
      password: passengerUserRequestDto.password,
      addresses: passengerUserRequestDto.addresses,
      carrierId: this._identityService.userId,
      acceptSimultaneousTrip: passengerUserRequestDto.acceptSimultaneousTrip,
      travelFareId: travelFareId,
      family: passengerUserRequestDto.family,
      enableFamilyGroup: passengerUserRequestDto.enableFamilyGroup,
      isPaxVip: passengerUserRequestDto.isPaxVip
    });
    return this._connectionService
      .Request(addPassengerCommand)
      .pipe(
        map(data => {
          // this._alertService.alertWarning(
          //   'toast.users.title',
          //   'toast.shared.message.successful_message_add'
          // );
          return data as PassengerResponseDTO;
        }),
        catchError(error => {
          if (error.status === 409) {
            let message = '';
            if (error.error?.errorCode === 'MAIL_UNIQUE') {
              message = 'toast.users.error_code.mail_unique';
            } else if (error.error?.errorCode === 'PHONE_UNIQUE') {
              message = 'toast.users.error_code.phone_unique';
            } else {
              message = 'toast.users.error_code.conflict';
            }
            this._alertService.alertWarning('toast.users.title', message);
          } else {
            this._alertService.alertWarning('toast.users.title', error);
          }
          return throwError(() => error);
        })
      );
  }

  public updatePassengerUser(
    passengerUserId: number,
    passengerUserRequestDto: IAddPassengerUserRequestDto
  ): Observable<PassengerResponseDTO> {
    let updatePassengerCommand = new UpdatePassengerUserCommand(
      this._identityService.userId,
      passengerUserId.toString()
    );
    updatePassengerCommand.setParameters(<IUpdatePassengerUserParameters>{
      country: passengerUserRequestDto.country,
      firstName: passengerUserRequestDto.firstName,
      lastName: passengerUserRequestDto.lastName,
      email: passengerUserRequestDto.email,
      phone: passengerUserRequestDto.phone,
      addresses: passengerUserRequestDto.addresses,
      acceptSimultaneousTrip: passengerUserRequestDto.acceptSimultaneousTrip,
      family: passengerUserRequestDto.family,
      enableFamilyGroup: passengerUserRequestDto.enableFamilyGroup,
      isPaxVip: passengerUserRequestDto.isPaxVip
    });
    return this._connectionService
      .Request(updatePassengerCommand)
      .pipe(
        map(data => {
          this._alertService.alertSuccess(
            'toast.users.title',
            'toast.shared.message.successful_message_update'
          );
          return data as PassengerResponseDTO;
        }),
        catchError(error => {
          if (error.status === 409) {
            let message = '';
            if (error.error?.errorCode === 'MAIL_UNIQUE') {
              message = 'toast.users.error_code.mail_unique';
            } else if (error.error?.errorCode === 'PHONE_UNIQUE') {
              message = 'toast.users.error_code.phone_unique';
            } else {
              message = 'toast.users.error_code.conflict';
            }
            this._alertService.alertWarning('toast.users.title', message);
          } else {
            this._alertService.alertWarning('toast.users.title', error);
          }
          return throwError(() => error);
        })
      );
  }

  public importClients(csv: File,
    carrier: string, country: string, importType: string): Observable<IImportPassengerUsersResponse> {
    let importPssengerUsersCommand = new ImportPassengerUsersCommand();
    let form = new FormData()
    form.append('country', country)
    form.append('csv', csv, csv.name)
    form.append('carrier', carrier)
    form.append('importType', importType)
    importPssengerUsersCommand.setParameters(form);
    return this._connectionService
      .Request(importPssengerUsersCommand)
      .pipe(
        map(data => {
          if (data.successLines > 0) {
            this._alertService.alertSuccess(
              'toast.users.title',
              this._translateService.instant('carrier.clients.passenger_management.import.success_message')
                .replace('{lines}', data.successLines)
            );
          }
          return data;
        }),
        catchError(error => {
          this._alertService.alertWarning('toast.users.title', error);
          return throwError(() => false);
        })
      );
  }

  // public updateClientIsActive(
  //   clientIsActive: ClientIsActiveRequestDto
  // ): Observable<IUpdateClientIsActiveCommand> {
  //   const driverCommand = new UpdateClientIsActiveCommand();
  //   driverCommand.setParameters(<IUpdateClientIsActiveCommandParameters>{
  //     clientUserId: clientIsActive.clientUserId,
  //     enabled: clientIsActive.enabled,
  //     carrierUserId: clientIsActive.carrierUserId
  //   });

  //   return this._connectionService
  //     .Request(driverCommand)
  //     .map(response => {
  //       this._notificationsService.showSuccessMessage(
  //         'toast.clients.title',
  //         'toast.clients.message.client_edited'
  //       );
  //       return response;
  //     })
  //     .catch(error => {
  //       if (error.error != null && error.error.errorCode != null) {
  //         if (error.error.errorCode === ErrorsEnum.CLIENT_NOT_FOUND) {
  //           this._notificationsService.showInternalErrorMessage(
  //             'toast.clients.title',
  //             'toast.driver.error_code.selected_not_found'
  //           );
  //         } else if (error.error.errorCode === ErrorsEnum.CARRIER_NOT_FOUND) {
  //           this._notificationsService.showInternalErrorMessage(
  //             'toast.clients.title',
  //             'toast.carrier.error_code.carrier_selected_not_found'
  //           );
  //         } else {
  //           this._notificationsService.showHttpErrorMessage('toast.clients.title', error);
  //         }
  //       }
  //       return Observable.throw(false);
  //     });
  // }

  public getFrequentDestinationPassenger(
    id: string,
    destinationType: string
  ): Observable<IGetFequentDestinationResponse> {
    const frequentDestinationCommand = new GetFequentDestinationCommand();
    frequentDestinationCommand.setParameters(<IGetFequentDestinationCommandParameters>{
      id: id,
      destinationType: destinationType
    });


    return this._connectionService
      .Request(frequentDestinationCommand)
      .pipe(
        map(response => {
          return response as any;
        }),
        catchError(() => {
          // this._notificationsService.showHttpErrorMessage(
          //   'toast.configuration.frequent_destinations',
          //   error
          // );
          return throwError(() => false);
        }));
  }

  public getTravelsCheckingAccountByPassenger(
    clientId: number,
    sorting: SortGrid
  ): Observable<PaginationResult<TravelsCheckingAccountResponse>> {
    const command = new GetClientTravelsCheckingAccountCommand();
    command.setUrlParameters(clientId, sorting);

    return this._connectionService
      .Request(command)
      .pipe(
        map(response => {
          return response as PaginationResult<TravelsCheckingAccountResponse>;
        }),
        catchError(error => {
          return throwError(() => false);
        })
      );
  }

  public getAddressesById(
    passengerId: number
  ): Observable<IPassengerAddressDto[]> {
    const command = new GetPassengersAddressesCommand();
    const params: IGetPassengerAddressCommandParameters = {
      passengerId
    }
    command.setParameters(params);

    return this._connectionService
      .Request(command)
      .pipe(
        map(response => {
          return response as any;
        }),
        catchError(() => {
          return throwError(() => false);
        }));
  }

  // public getPaymentVoucherByRelation(
  //   contractorId: number
  // ): Observable<IGetPaymentVoucheByRelationResponse> {
  //   const getPaymentVoucherCommand = new GetPaymentVoucherByRelationCommand();
  //   getPaymentVoucherCommand.setParameters(<
  //     IGetPaymentVoucherByRelationCommandParameters
  //   >{
  //     carrierId: +this._identityService.userId,
  //     contractorId: contractorId
  //   });
  //   return this._connectionService
  //     .Request(getPaymentVoucherCommand)
  //     .map(response => {
  //       return response;
  //     })
  //     .catch(error => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.checking_accounts.receipt',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // deleteClient(id:string): Observable<boolean> {

  //   let deleteClientCommand = new DeleteClientCommand(
  //     this._identityService.userId, id
  //   );
  //   deleteClientCommand.setParameters(<IDeleteClientParameters>{
  //     carrierId: this._identityService.userId,
  //     clientId: id
  //   });
  //   return this._connectionService
  //     .Request(deleteClientCommand)
  //     .map(data => {
  //       this._notificationsService.showSuccessMessage(
  //         'toast.clients.title',
  //         'toast.clients.message.client_deleted'
  //       );
  //       return true;
  //     })
  //     .catch(error => {
  //       if (error.error.message === "RELATION_HAS_PENDING_LIQUIDATION") {
  //         this._notificationsService.showInternalErrorMessage(
  //           'toast.clients.title',
  //           'toast.contractor.error_code.relation_has_pending_liquidation'
  //         );
  //       } else
  //         if (error.error.message === "IS_COMPANY") {
  //           this._notificationsService.showInternalErrorMessage(
  //             'toast.clients.title',
  //             'toast.clients.error_code.is_company'
  //           );
  //         } else {
  //           this._notificationsService.showInternalErrorMessage(
  //             'toast.clients.title',
  //             'toast.clients.error_code.client'
  //           );
  //         }
  //         return Observable.throw(false);
  //     });
  // }

  // public resendSolicitude(passengerAccountId:Number){
  //   let command = new PassengerResendSolicitudeCommand();
  //  const params: IPassengerResendSolicitudeParameters = {
  //   passengerUserId: passengerAccountId
  //   };
  //   command.setParameters(params);
  //   return this._connectionService
  //     .Request(command)
  //     .map(data => {
  //       this._notificationsService.showSuccessMessage(
  //         'toast.clients.title',
  //         'toast.general.resend_email_success'
  //       );
  //       return true;
  //     })
  //     .catch(error => {

  //           this._notificationsService.showInternalErrorMessage(
  //             'toast.clients.title',
  //             'toast.general.resend_email_error'
  //           );

  //       return Observable.throw(false);
  //     });
  // }

  getPaymentsMethodsByPax(passengerUserId: number, type: string, carrierId?: number): Observable<PaymentResponseDTO> {
    const command = new GetPaymentMethodsByPaxCommand();
    command.setUrlParameter(carrierId ? carrierId.toString() : this._identityService.userId);
    command.setParameters(<IGetPaymentMethodsByPaxCommandCommandParameters>{
      passengerId: passengerUserId,
      typeConfig: type
    });

    return this._connectionService
      .Request(command)
      .pipe(map(data => {
        const response = data as PaymentResponseDTO;
        return response;
      }))
      .pipe(catchError(error => {
        return throwError(() => error);
      }));
  }

  /**
   * MX-5600: Get total individual clients count for dashboard Card 5.
   * Endpoint: GET carriers/{carrierId}/clients/totalClients
   */
  public getTotalClients(): Observable<{ countLocal: number; countPassenger: number }> {
    const command = new GetCountClientCommand();
    command.setParameters(<IGetCountClientCommandParameters>{
      carrierUserId: this._identityService.userId
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map(data => data as { countLocal: number; countPassenger: number }),
        catchError(error => {
          console.error('Error fetching total clients:', error);
          return throwError(() => error);
        })
      );
  }
}
